// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-body[data-v-409615cc] {\n  flex-grow: 1;\n}\n.multiselect-campaign-wrapper[data-v-409615cc] {\n  flex-grow: 1;\n  max-width: 700px;\n}", ""]);
// Exports
module.exports = exports;
